var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex flex-column mb-6"},[_c('v-btn',{staticClass:"mt-5",attrs:{"color":"primary","disabled":""},on:{"click":_vm.createUser}},[_vm._v("Erstellen")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }